import { Component, OnInit, HostListener } from '@angular/core';
import { Globals } from '../../../../environments/Globals';
import { CommonConstant } from '../../constent/applicationcodes';
import { Router } from '@angular/router';

export interface HeaderNotificationItem {
    id: string;
    title: string;
    message: string;
    time: string;
    icon: string;
    route?: string;
    action?: string;
}

declare var $: any;

@Component({
    selector: 'app-header-notifications',
    templateUrl: './header-notifications.component.html',
    styleUrls: ['./header-notifications.component.css']
})
export class HeaderNotificationsComponent implements OnInit {
    notifications: HeaderNotificationItem[] = [];
    showPanel = false;
    commonconstant = new CommonConstant();

    constructor(private globals: Globals, private router: Router) { }

    ngOnInit(): void {
        this.buildNotifications();
    }

    get unreadCount(): number {
        if (this.notifications.length === 1 && this.notifications[0].id === 'welcome') {
            return 0;
        }
        return this.notifications.length;
    }

    togglePanel(event: Event): void {
        event.stopPropagation();
        this.showPanel = !this.showPanel;
    }

    closePanel(): void {
        this.showPanel = false;
    }

    openNotification(item: HeaderNotificationItem): void {
        this.showPanel = false;

        if (item.action === 'lowStock') {
            if (typeof $('.importModal34').animate === 'function') {
                $('.importModal34').animate({ width: 'toggle' });
            }
            return;
        }

        if (item.route) {
            this.router.navigate([item.route]);
        }
    }

    markAllRead(): void {
        this.notifications = [];
        this.showPanel = false;
        this.globals.setDataInLocalStorage(this.commonconstant.UnPostedNotificationRead, true);
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        if (!target.closest('.header-notifications-wrap')) {
            this.showPanel = false;
        }
    }

    private buildNotifications(): void {
        const items: HeaderNotificationItem[] = [];
        const unpostedPOS = Number(this.globals.getDataFromLocalStorage(this.commonconstant.UnPostedPOSInvoices));
        const lowStock = this.globals.getBoolFromLocalStorage(String(this.commonconstant.IsProductOnLowQuantity));
        const fundsTransferred = this.globals.getBoolFromLocalStorage(this.commonconstant.IsShowNewFundsTransferred);
        const daysLeft = Number(this.globals.getDataFromLocalStorage(this.commonconstant.DaysLeft));
        const isDemoUser = this.globals.getBoolFromLocalStorage(this.commonconstant.IsDemoClient);

        if (unpostedPOS > 0) {
            items.push({
                id: 'pos-unposted',
                title: 'Unposted POS Invoices',
                message: unpostedPOS + ' invoice(s) waiting to be posted.',
                time: 'Today',
                icon: 'os-icon os-icon-coins-4',
                route: '/POS/Invoice'
            });
        }

        if (lowStock) {
            items.push({
                id: 'low-stock',
                title: 'Low Stock Alert',
                message: 'Some products are below minimum quantity.',
                time: 'Today',
                icon: 'os-icon os-icon-box',
                action: 'lowStock'
            });
        }

        if (fundsTransferred) {
            items.push({
                id: 'funds-transfer',
                title: 'Funds Transferred',
                message: 'New fund transfer requires your review.',
                time: 'Recent',
                icon: 'os-icon os-icon-wallet-loaded',
                route: '/Finance/FundsTransfer'
            });
        }

        if (!isDemoUser && daysLeft > 0 && daysLeft < 21) {
            items.push({
                id: 'license-expiry',
                title: 'License Expiring',
                message: 'Your license expires in ' + daysLeft + ' day(s).',
                time: 'Alert',
                icon: 'os-icon os-icon-alert-circle',
                route: '/Configuration/Company/Profile'
            });
        }

        if (items.length === 0) {
            items.push({
                id: 'welcome',
                title: 'All caught up',
                message: 'No new notifications at the moment.',
                time: 'Now',
                icon: 'os-icon os-icon-check-circle'
            });
        }

        this.notifications = items;
    }
}
